import { render } from "./MediaSwitch.vue?vue&type=template&id=e3d0589e&scoped=true"
import script from "./MediaSwitch.vue?vue&type=script&lang=js"
export * from "./MediaSwitch.vue?vue&type=script&lang=js"

import "./MediaSwitch.vue?vue&type=style&index=0&id=e3d0589e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3d0589e"]])

export default __exports__